import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NB_AUTH_OPTIONS } from '../../auth.options';
import { getDeepFromObject } from '../../helpers';
import { ApiService } from '../../../services/api.service';
import { URLConfig } from '../../../../configs/url-config';

@Component({
  selector: 'nb-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NbVerifyEmailComponent implements OnInit {
  redirectDelay = 0;
  showMessages: any = {};
  strategy = '';
  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  email = '';
  code = '';
  verificationComplete = false;

  constructor(
    private _apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    protected cd: ChangeDetectorRef,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
  ) {
    this.redirectDelay = this.getConfigValue('forms.login.redirectDelay');
    this.showMessages = this.getConfigValue('forms.login.showMessages');
    this.strategy = this.getConfigValue('forms.login.strategy');
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.email = params?.email || '';
      this.code = params?.code || '';

      if (this.email && this.code) {
        this.verifyEmail();
        return;
      }

      this.cd.detectChanges();
    });
  }

  verifyEmail(): void {
    if (!this.email || !this.code) {
      this._apiService.warning('Missing verification code or email.');
      return;
    }

    this.submitted = true;
    const url = `${URLConfig.adminVerifyEmail}?email=${encodeURIComponent(this.email)}&code=${encodeURIComponent(this.code)}`;
    this._apiService.postRequest(url, {}).subscribe(
      (result: any) => {
        this.verificationComplete = true;
        this._apiService.success('Email verified successfully.');
        this.handleLoginResponse(result);
      },
      () => {
        this.submitted = false;
        this._apiService.error('Email verification failed. Please use the latest verification link.');
        this.cd.detectChanges();
      },
    );
  }

  continueLogin(): void {
    this.router.navigate(['/auth/login']);
  }

  resendVerificationEmail(): void {
    if (!this.email) {
      this._apiService.warning('Email is required.');
      return;
    }

    this.submitted = true;
    const url = `${URLConfig.sendVerificationEmailAdmin}?email=${encodeURIComponent(this.email)}`;
    this._apiService.postRequest(url, {}).subscribe(
      () => {
        this.submitted = false;
        this._apiService.success('Verification email sent.');
        this.cd.detectChanges();
      },
      () => {
        this.submitted = false;
        this._apiService.error('Unable to send verification email.');
        this.cd.detectChanges();
      },
    );
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }

  private handleLoginResponse(payload: any): void {
    const userData = this._apiService.extractAuthData(payload);
    // if (!this._apiService.isEmailVerified(userData)) {
    //   this.submitted = false;
    //   this._apiService.warning('Email is still not verified.');
    //   this.cd.detectChanges();
    //   return;
    // }

    this._apiService.saveAuthSession(userData);
    this._apiService.success('Login Successfully');
    this.router.navigate(['/pages/dashboard']);
    this.submitted = false;
    this.cd.detectChanges();
  }
}
